import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreateRecipientChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .833008,
		y: .5,
		width: 24,
		height: 24,
		rx: 12,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.833 8.5L11.3131 15.792C10.9119 16.1811 10.2697 16.1658 9.88743 15.7581L6.83301 12.5",
		stroke: "#EF4444",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})]
});
export default SvgCreateRecipientChecked;
